export default "__VITE_ASSET__173837b0__"